"use strict";
/**
 * OpenSearch index-definitions barrel — the single import surface for the canonical
 * per-family field-name constants and template builders defined in the
 * canonical-shared-types model (tasks 1.1–1.5).
 *
 * Each registrar (setup lambda, reindex script) and consumer (indexer writer, search
 * reader) imports a family's field constants and template body from here, so the
 * contract, writer, reader, and mapping all bottom out on one source.
 *
 * NOTE on the `MATERIAL_FIELDS` / `MaterialField` re-export: both
 * `materials-public-definition` and `materials-personal-definition` surface those two
 * names (the personal family shares the public family's constants). To avoid a
 * duplicate re-export (TS2308), they are exported here ONLY via
 * `materials-public-definition`, and `materials-personal-definition` is re-exported
 * explicitly for just its builder.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildMaterialsPersonalTemplate = void 0;
__exportStar(require("./template-types"), exports);
__exportStar(require("./pattern-definition"), exports);
__exportStar(require("./user-definition"), exports);
__exportStar(require("./materials-public-definition"), exports);
// materials-personal shares MATERIAL_FIELDS/MaterialField with materials-public (already
// exported above); re-export only its builder to avoid a duplicate-export conflict.
var materials_personal_definition_1 = require("./materials-personal-definition");
Object.defineProperty(exports, "buildMaterialsPersonalTemplate", { enumerable: true, get: function () { return materials_personal_definition_1.buildMaterialsPersonalTemplate; } });
__exportStar(require("./projects-public-definition"), exports);
__exportStar(require("./collections-definition"), exports);
__exportStar(require("./moderation"), exports);
// NEW contract interfaces created in tasks 1.3/1.4 — surfaced at root so
// UserSearchDocument / CollectionSearchDocument are available alongside the definitions.
__exportStar(require("./user"), exports);
__exportStar(require("./collection"), exports);
